import { EventEmitter, Injectable } from '@angular/core';
import { FeatureMenuItem } from '@app/features/feature.menu.item';
import { BehaviorSubject, Observable } from 'rxjs';
import { EvaluationShowType } from '../../../api/evaluation';
import { ReportMenuNames } from '../../helpers';

export enum enmMenuType {
  Patient,
  PatientConsultation,
  Configuration,
  Profile
}
export interface Menudata {
  items: FeatureMenuItem[],
  showExit: boolean,
  type: enmMenuType
}

@Injectable({
  providedIn: 'root'
})
export class AsMenuService {
  onResetPatientDataMenu: EventEmitter<any> = new EventEmitter();
  onConfirmPatientData: EventEmitter<any> = new EventEmitter();
  private _menuBrahvior: BehaviorSubject<Menudata> = new BehaviorSubject(null);

  get menu(): Observable<Menudata> {
    return this._menuBrahvior.asObservable();
  }
  constructor() { }

  setMenu(menu: Menudata) {
    this._menuBrahvior.next(menu)
  }

  filterMenuByTitle(title: string) {
    let filterMenu = this._menuBrahvior.value as Menudata;
    if (filterMenu && filterMenu.items) {
      filterMenu.items = filterMenu.items.filter(i => i.title !== title);
      this._menuBrahvior.next(filterMenu);
    }
  }

  resetPatientDataMenu() {
    this.onResetPatientDataMenu.emit(null);
  }

  confirmPatientData() {
    this.onConfirmPatientData.emit(null);
  }

  resetReportsMenu(type: EvaluationShowType) {
    if (type === EvaluationShowType.NONE) {
      this.filterMenuByTitle(ReportMenuNames.REPORTES_2C);
      this.filterMenuByTitle(ReportMenuNames.REPORTES_5C);
    } else if (type === EvaluationShowType.FA5C) {
      this.filterMenuByTitle(ReportMenuNames.REPORTES_2C);
    } else if (type === EvaluationShowType.FA2C) {
      this.filterMenuByTitle(ReportMenuNames.REPORTES_5C);
    }
  }
}
